// /opt/isp_erp/frontend/src/pages/warehouse/NuevoEquipo.jsx
import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Grid,
  Alert,
  Snackbar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Paper,
  Tabs,
  Tab,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Divider
} from '@mui/material';
import {
  AddCircleOutline,
  Save,
  Cancel,
  Inventory,
  Assignment,
  Search,
  Delete,
  Undo
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { warehouseAPI } from '../../api/warehouse.api';
import axios from '../../api/axios';
import { cargarUsuariosDeSucursal } from '../../utils/usuariosSucursal';
import ProveedoresPanel from '../../components/warehouse/ProveedoresPanel';
import IngresosMaterialesPanel from '../../components/warehouse/IngresosMaterialesPanel';
import ImportarEquiposExcel from '../../components/warehouse/ImportarEquiposExcel';
import LotesEquiposPanel from '../../components/warehouse/LotesEquiposPanel';

const NuevoEquipo = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [snError, setSnError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [tabValue, setTabValue] = useState(0);

  // ==================== ESTADO PARA EQUIPO (EXISTENTE) ====================
  const [formData, setFormData] = useState({
    sn: '',
    modelo: '',
    onu_id: '',
    observaciones: '',
    es_nuevo: true,
    proveedor_id: '',
    tipo: '',
    documento_compra: '',
    fecha_compra: '',
    costo_unitario: ''
  });

  // ==================== ESTADO PARA MATERIAL (NUEVO) ====================
  const [materialForm, setMaterialForm] = useState({
    codigo: '',
    proveedor_id: '',
    nombre: '',
    tipo: 'FIBRA',
    unidad: 'METROS',
    precio_unitario: 0,
    stock_minimo: 0,
    stock_bodega: 0,
    observaciones: ''
  });

  const [materiales, setMateriales] = useState([]);
  const [searchMaterial, setSearchMaterial] = useState('');
  const [proveedores, setProveedores] = useState([]);
  useEffect(() => {
    axios.get('/warehouse/proveedores/opciones')
      .then((r) => setProveedores(r.data || []))
      .catch(() => setProveedores([]));
  }, [tabValue]);

  // ==================== ESTADO PARA ASIGNAR MATERIAL A TÉCNICO ====================
  const [asignarMaterial, setAsignarMaterial] = useState({
    material_id: '',
    tecnico_id: '',
    cantidad: '1'   // ✅ CAMBIO 1: string
  });
  const [tecnicos, setTecnicos] = useState([]);
  const [asignarDialogOpen, setAsignarDialogOpen] = useState(false);
  const [selectedMaterial, setSelectedMaterial] = useState(null);

  // ==================== ESTADO PARA VIÑETA ====================
  const [vignetteForm, setVignetteForm] = useState({
    serial: '',
    nombre: ''
  });
  const [vignettes, setVignettes] = useState([]);
  const [searchVignette, setSearchVignette] = useState('');

  // ==================== ESTADO PARA ASIGNAR VIÑETA A TÉCNICO ====================
  const [asignarVignette, setAsignarVignette] = useState({
    vignette_id: '',
    tecnico_id: ''
  });
  const [asignarVignetteOpen, setAsignarVignetteOpen] = useState(false);
  const [selectedVignette, setSelectedVignette] = useState(null);

  // ✅ Estado para stock disponible en bodega
  const [stockDisponible, setStockDisponible] = useState(0);
  const [cargandoStock, setCargandoStock] = useState(false);

  // Cargar datos al montar
  useEffect(() => {
    if (tabValue === 1 || tabValue === 2) {
      cargarMateriales();
    }
    if (tabValue === 2) {
      cargarTecnicos();
    }
    if (tabValue === 3) {
      cargarVignettes();
      cargarTecnicos();
    }
  }, [tabValue]);

  const cargarMateriales = async () => {
    try {
      const response = await axios.get('/warehouse/materiales');
      setMateriales(response.data || []);
    } catch (error) {
      console.error('Error cargando materiales:', error);
    }
  };

  const cargarTecnicos = async () => {
    try {
      const response = await axios.get('/users');
      const usuarios = response.data || [];

      const tecnicosFiltrados = usuarios.filter(u => {
        if (u.roles && Array.isArray(u.roles)) {
          return u.roles.some(r =>
            r.name === 'tecnico_campo' ||
            r.name === 'admin' ||
            r.name === 'soporte_n2'
          );
        }
        return false;
      });

      // Los técnicos de una sucursal reciben su material, equipos y viñetas desde esa sucursal (Bodega → Sucursales)
      const enSucursal = await cargarUsuariosDeSucursal();
      setTecnicos(tecnicosFiltrados.filter((t) => !enSucursal.has(t.id)));
    } catch (error) {
      console.error('Error cargando técnicos:', error);
      setError('Error al cargar la lista de técnicos');
      setTecnicos([]);
    }
  };

  // ==================== FUNCIONES PARA VIÑETA ====================
  const cargarVignettes = async () => {
    try {
      const response = await axios.get('/warehouse/vignettes');
      setVignettes(response.data || []);
    } catch (error) {
      console.error('Error cargando viñetas:', error);
    }
  };

  const handleVignetteChange = (e) => {
    setVignetteForm({ ...vignetteForm, [e.target.name]: e.target.value });
  };

  const registrarVignette = async () => {
    if (!vignetteForm.serial || !vignetteForm.nombre) {
      setError('Complete los campos: Serial y Nombre');
      return;
    }

    setLoading(true);
    setError('');
    try {
      await axios.post('/warehouse/vignettes', vignetteForm);
      setSuccess(true);
      setVignetteForm({ serial: '', nombre: '' });
      cargarVignettes();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al registrar viñeta');
    } finally {
      setLoading(false);
    }
  };

  const asignarVignetteTecnico = async () => {
    if (!asignarVignette.vignette_id || !asignarVignette.tecnico_id) {
      setError('Seleccione una viñeta y un técnico');
      return;
    }

    setLoading(true);
    try {
      await axios.post('/warehouse/vignettes/asignar', asignarVignette);
      setAsignarVignetteOpen(false);
      setAsignarVignette({ vignette_id: '', tecnico_id: '' });
      setSuccess(true);
      cargarVignettes();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al asignar viñeta');
    } finally {
      setLoading(false);
    }
  };

  // ✅ FUNCIÓN PARA DEVOLVER VIÑETA A BODEGA
  const devolverVignette = async (id) => {
    if (!window.confirm('¿Está seguro de devolver esta viñeta a bodega?')) return;

    try {
      await axios.post('/warehouse/vignettes/devolver', { vignette_id: id });
      setSuccess(true);
      cargarVignettes();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al devolver viñeta');
    }
  };

  const eliminarVignette = async (id) => {
    if (!window.confirm('¿Está seguro de eliminar esta viñeta?')) return;

    try {
      await axios.delete(`/warehouse/vignettes/${id}`);
      setSuccess(true);
      cargarVignettes();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al eliminar viñeta');
    }
  };

  // ✅ Función para cargar stock disponible en bodega
  const cargarStockBodega = async (materialId) => {
    setCargandoStock(true);
    try {
      const response = await axios.get(`/warehouse/materiales/${materialId}/stock-bodega`);
      setStockDisponible(response.data.stock_bodega || 0);
    } catch (error) {
      console.error('Error cargando stock en bodega:', error);
      setStockDisponible(0);
    } finally {
      setCargandoStock(false);
    }
  };

  // ==================== MANEJADORES PARA EQUIPO ====================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (name === 'sn') {
      setSnError(false);
    }
  };

  const validateForm = () => {
    if (!formData.sn.trim()) {
      setSnError(true);
      return false;
    }
    if (!formData.modelo.trim()) {
      setError('El modelo es requerido');
      return false;
    }
    return true;
  };

  const handleSubmitEquipo = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    setError('');

    try {
      await warehouseAPI.registrarLoteEquipos({
        proveedor_id: formData.proveedor_id || null,
        documento_compra: formData.documento_compra.trim() || null,
        fecha_compra: formData.fecha_compra || null,
        equipos: [{
          sn: formData.sn.trim().toUpperCase(),
          modelo: formData.modelo.trim(),
          tipo: formData.tipo || null,
          observaciones: formData.observaciones || null,
          costo_unitario: formData.costo_unitario === '' ? null : parseFloat(formData.costo_unitario)
        }]
      });

      setSuccess(true);
      setTimeout(() => {
        navigate('/warehouse/equipos');
      }, 2000);
    } catch (err) {
      if (err.response?.status === 400) {
        setError(err.response.data.detail || 'El equipo ya existe');
        setSnError(true);
      } else {
        setError('Error al registrar el equipo');
      }
    } finally {
      setLoading(false);
    }
  };

  // ==================== MANEJADORES PARA MATERIAL ====================
  const handleMaterialChange = (e) => {
    setMaterialForm({ ...materialForm, [e.target.name]: e.target.value });
  };

  const registrarMaterial = async () => {
    if (!materialForm.codigo || !materialForm.nombre) {
      setError('Complete los campos obligatorios: Código y Nombre');
      return;
    }

    setLoading(true);
    setError('');
    try {
      await axios.post('/warehouse/materiales', materialForm);
      setSuccess(true);
      setMaterialForm({
        codigo: '',
        nombre: '',
        tipo: 'FIBRA',
        unidad: 'METROS',
        precio_unitario: 0,
        stock_minimo: 0,
        stock_bodega: 0,
        observaciones: ''
      });
      cargarMateriales();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al registrar material');
    } finally {
      setLoading(false);
    }
  };

  // ==================== MANEJADORES PARA ASIGNAR MATERIAL ====================
  const asignarMaterialTecnico = async () => {
    // ✅ CAMBIO 3: Convertir a número al validar
    const cantidadNum = parseFloat(asignarMaterial.cantidad);

    if (!asignarMaterial.material_id || !asignarMaterial.tecnico_id || isNaN(cantidadNum) || cantidadNum <= 0) {
      setError('Complete todos los campos con valores válidos');
      return;
    }

    if (cantidadNum > stockDisponible) {
      setError(`No hay suficiente stock. Disponible: ${stockDisponible}`);
      return;
    }

    setLoading(true);
    try {
      await axios.post('/warehouse/materiales/asignar-tecnico', null, {
        params: {
          material_id: asignarMaterial.material_id,
          tecnico_id: asignarMaterial.tecnico_id,
          cantidad: cantidadNum
        }
      });
      setAsignarDialogOpen(false);
      setAsignarMaterial({ material_id: '', tecnico_id: '', cantidad: '1' });  // ✅ string
      setStockDisponible(0);
      setSuccess(true);
      cargarMateriales();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al asignar material');
    } finally {
      setLoading(false);
    }
  };

  const getTipoColor = (tipo) => {
    const colors = { FIBRA: 'primary', CONECTOR: 'secondary', CAJA: 'success', SPLITTER: 'warning', OTRO: 'default' };
    return colors[tipo] || 'default';
  };

  const filteredMateriales = materiales.filter(m =>
    m.nombre?.toLowerCase().includes(searchMaterial.toLowerCase()) ||
    m.codigo?.toLowerCase().includes(searchMaterial.toLowerCase()) ||
    m.proveedor?.toLowerCase().includes(searchMaterial.toLowerCase())
  );

  const filteredVignettes = vignettes.filter(v =>
    v.serial?.toLowerCase().includes(searchVignette.toLowerCase()) ||
    v.nombre?.toLowerCase().includes(searchVignette.toLowerCase())
  );

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Registro de Bodega
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Registre equipos (ONU, Router, etc.), materiales (fibra, conectores, etc.) o viñetas
      </Typography>

      <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}>
        <Tab label="📡 Equipos" icon={<Inventory />} iconPosition="start" />
        <Tab label="📦 Materiales" icon={<Inventory />} iconPosition="start" />
        <Tab label="📋 Asignar a Técnicos" icon={<Assignment />} iconPosition="start" />
        <Tab label="🏷️ Viñetas" icon={<Inventory />} iconPosition="start" />
        <Tab label="🏢 Proveedores" icon={<Inventory />} iconPosition="start" />
        <Tab label="📥 Ingresos de materiales" icon={<Assignment />} iconPosition="start" />
        <Tab label="📦 Lotes de equipos" icon={<Inventory />} iconPosition="start" />
      </Tabs>

      {/* ==================== TAB 1: REGISTRAR EQUIPO ==================== */}
      {tabValue === 0 && (
        <Card>
          <CardContent>
            <ImportarEquiposExcel />
            <form onSubmit={handleSubmitEquipo}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Número de Serie (SN) *"
                    name="sn"
                    value={formData.sn}
                    onChange={handleChange}
                    error={snError}
                    helperText={snError ? 'El número de serie es requerido' : ''}
                    placeholder="Ej: ONT123456789"
                    autoFocus
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Modelo *"
                    name="modelo"
                    value={formData.modelo}
                    onChange={handleChange}
                    placeholder="Ej: HG8245H, EG8145V5, etc."
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel>Proveedor</InputLabel>
                    <Select name="proveedor_id" value={formData.proveedor_id ?? ''} onChange={handleChange} label="Proveedor">
                      <MenuItem value="">Sin proveedor</MenuItem>
                      {proveedores.map((p) => (
                        <MenuItem key={p.id} value={p.id}>{p.nombre}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <InputLabel>Tipo de equipo</InputLabel>
                    <Select name="tipo" value={formData.tipo} onChange={handleChange} label="Tipo de equipo">
                      <MenuItem value="">Sin especificar</MenuItem>
                      {['ONU', 'ROUTER', 'AP', 'SWITCH', 'OTRO'].map((t) => (
                        <MenuItem key={t} value={t}>{t}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField fullWidth label="Factura / documento de compra" name="documento_compra" value={formData.documento_compra} onChange={handleChange} />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField fullWidth type="date" label="Fecha de compra" name="fecha_compra" value={formData.fecha_compra} onChange={handleChange} InputLabelProps={{ shrink: true }} />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField fullWidth type="number" label="Costo unitario (opcional)" name="costo_unitario" value={formData.costo_unitario} onChange={handleChange} inputProps={{ min: 0, step: 'any' }} />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Observaciones"
                    name="observaciones"
                    multiline
                    rows={3}
                    value={formData.observaciones}
                    onChange={handleChange}
                    placeholder="Estado del equipo, procedencia, etc."
                  />
                </Grid>

                <Grid item xs={12}>
                  <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Información:</strong> El equipo se registrará en estado <strong>BODEGA</strong>
                      y estará disponible para ser despachado a técnicos.
                    </Typography>
                  </Paper>
                </Grid>

                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                    <Button
                      variant="outlined"
                      onClick={() => navigate('/warehouse/equipos')}
                      startIcon={<Cancel />}
                    >
                      Cancelar
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      disabled={loading}
                      startIcon={loading ? <CircularProgress size={20} /> : <Save />}
                    >
                      {loading ? 'Guardando...' : 'Registrar Equipo'}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
      )}

      {/* ==================== TAB 2: REGISTRAR MATERIAL ==================== */}
      {tabValue === 1 && (
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>Registrar Nuevo Material</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormControl fullWidth size="small">
                  <InputLabel>Proveedor</InputLabel>
                  <Select name="proveedor_id" value={materialForm.proveedor_id ?? ''} onChange={handleMaterialChange} label="Proveedor">
                    <MenuItem value="">Sin proveedor</MenuItem>
                    {proveedores.map((p) => (
                      <MenuItem key={p.id} value={p.id}>{p.nombre}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Código *"
                  name="codigo"
                  value={materialForm.codigo}
                  onChange={handleMaterialChange}
                  required
                  size="small"
                  helperText="Ej: FIBRA-OS2, CON-SC-APC"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Nombre *"
                  name="nombre"
                  value={materialForm.nombre}
                  onChange={handleMaterialChange}
                  required
                  size="small"
                  helperText="Ej: Fibra Óptica Monomodo OS2"
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel>Tipo</InputLabel>
                  <Select name="tipo" value={materialForm.tipo} onChange={handleMaterialChange} label="Tipo">
                    <MenuItem value="FIBRA">📡 Fibra Óptica</MenuItem>
                    <MenuItem value="CONECTOR">🔌 Conector</MenuItem>
                    <MenuItem value="CAJA">📦 Caja</MenuItem>
                    <MenuItem value="SPLITTER">🔄 Splitter</MenuItem>
                    <MenuItem value="OTRO">📦 Otro</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel>Unidad</InputLabel>
                  <Select name="unidad" value={materialForm.unidad} onChange={handleMaterialChange} label="Unidad">
                    <MenuItem value="METROS">Metros</MenuItem>
                    <MenuItem value="UNIDAD">Unidad</MenuItem>
                    <MenuItem value="CAJA">Caja</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField
                  fullWidth
                  type="number"
                  label="Precio Unitario"
                  name="precio_unitario"
                  value={materialForm.precio_unitario}
                  onChange={handleMaterialChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField
                  fullWidth
                  type="number"
                  label="Stock Mínimo"
                  name="stock_minimo"
                  value={materialForm.stock_minimo}
                  onChange={handleMaterialChange}
                  size="small"
                  helperText="Alerta cuando stock baje de este valor"
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField
                  fullWidth
                  type="number"
                  label="Stock en Bodega"
                  name="stock_bodega"
                  value={materialForm.stock_bodega || 0}
                  onChange={handleMaterialChange}
                  size="small"
                  helperText="Cantidad disponible en bodega"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Observaciones"
                  name="observaciones"
                  value={materialForm.observaciones}
                  onChange={handleMaterialChange}
                  multiline
                  rows={2}
                  size="small"
                />
              </Grid>
            </Grid>

            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 3 }}>
              <Button variant="outlined" onClick={() => setMaterialForm({
                codigo: '', nombre: '', tipo: 'FIBRA', unidad: 'METROS', precio_unitario: 0, stock_minimo: 0, stock_bodega: 0, observaciones: ''
              })} startIcon={<Cancel />}>
                Limpiar
              </Button>
              <Button variant="contained" onClick={registrarMaterial} disabled={loading} startIcon={loading ? <CircularProgress size={20} /> : <Save />}>
                Registrar Material
              </Button>
            </Box>
          </CardContent>
        </Card>
      )}

      {/* ==================== TAB 3: ASIGNAR MATERIAL A TÉCNICOS ==================== */}
      {tabValue === 2 && (
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>Catálogo de Materiales</Typography>

            <TextField
              fullWidth
              placeholder="Buscar material por nombre o código..."
              size="small"
              value={searchMaterial}
              onChange={(e) => setSearchMaterial(e.target.value)}
              InputProps={{ startAdornment: <Search sx={{ mr: 1, color: 'text.secondary' }} /> }}
              sx={{ mb: 2 }}
            />

            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Código</TableCell>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Tipo</TableCell>
                    <TableCell>Unidad</TableCell>
                    <TableCell>Proveedor</TableCell>
                    <TableCell>Observaciones</TableCell>
                    <TableCell>Stock Mínimo</TableCell>
                    <TableCell align="center">Stock Bodega</TableCell>
                    <TableCell align="center">Asignar a Técnico</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredMateriales.length === 0 ? (
                    <TableRow><TableCell colSpan={9} align="center">No hay materiales registrados</TableCell></TableRow>
                  ) : (
                    filteredMateriales.map((m) => (
                      <TableRow key={m.id}>
                        <TableCell><strong>{m.codigo}</strong></TableCell>
                        <TableCell>{m.nombre}</TableCell>
                        <TableCell><Chip label={m.tipo} size="small" color={getTipoColor(m.tipo)} /></TableCell>
                        <TableCell>{m.unidad}</TableCell>
                        <TableCell>{m.proveedor || '—'}</TableCell>
                        <TableCell sx={{ maxWidth: 220 }}>{m.observaciones || '—'}</TableCell>
                        <TableCell>{m.stock_minimo}</TableCell>
                        <TableCell align="center">
                          <Chip
                            label={m.stock_bodega || 0}
                            size="small"
                            color={(m.stock_bodega || 0) > 0 ? "success" : "error"}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            size="small"
                            variant="outlined"
                            startIcon={<Assignment />}
                            onClick={() => {
                              setSelectedMaterial(m);
                              // ✅ CAMBIO 4: cantidad como string
                              setAsignarMaterial({ ...asignarMaterial, material_id: m.id, cantidad: '1' });
                              cargarStockBodega(m.id);
                              setAsignarDialogOpen(true);
                            }}
                            disabled={(m.stock_bodega || 0) <= 0}
                          >
                            Asignar
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}

      {/* ==================== TAB 4: VIÑETAS ==================== */}
      {tabValue === 3 && (
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>Registrar Nueva Viñeta</Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Serial *"
                  name="serial"
                  value={vignetteForm.serial}
                  onChange={handleVignetteChange}
                  size="small"
                  placeholder="Ej: VIN-001"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Nombre *"
                  name="nombre"
                  value={vignetteForm.nombre}
                  onChange={handleVignetteChange}
                  size="small"
                  placeholder="Ej: Viñeta Cliente XYZ"
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  onClick={registrarVignette}
                  disabled={loading}
                  startIcon={loading ? <CircularProgress size={20} /> : <Save />}
                >
                  Registrar Viñeta
                </Button>
              </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" gutterBottom>Lista de Viñetas</Typography>

            <TextField
              fullWidth
              placeholder="Buscar viñeta por serial o nombre..."
              size="small"
              value={searchVignette}
              onChange={(e) => setSearchVignette(e.target.value)}
              InputProps={{ startAdornment: <Search sx={{ mr: 1, color: 'text.secondary' }} /> }}
              sx={{ mb: 2 }}
            />

            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Serial</TableCell>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Estado</TableCell>
                    <TableCell>Técnico</TableCell>
                    <TableCell align="center">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredVignettes.length === 0 ? (
                    <TableRow><TableCell colSpan={5} align="center">No hay viñetas registradas</TableCell></TableRow>
                  ) : (
                    filteredVignettes.map((v) => (
                      <TableRow key={v.id}>
                        <TableCell><strong>{v.serial}</strong></TableCell>
                        <TableCell>{v.nombre}</TableCell>
                        <TableCell>
                          <Chip
                            label={v.estado}
                            size="small"
                            color={v.estado === 'BODEGA' ? 'success' : 'primary'}
                          />
                        </TableCell>
                        <TableCell>{v.tecnico_nombre || '-'}</TableCell>
                        <TableCell align="center">
                          {v.estado === 'BODEGA' && (
                            <>
                              <Button
                                size="small"
                                variant="outlined"
                                startIcon={<Assignment />}
                                onClick={() => {
                                  setSelectedVignette(v);
                                  setAsignarVignette({ vignette_id: v.id, tecnico_id: '' });
                                  setAsignarVignetteOpen(true);
                                }}
                                sx={{ mr: 1 }}
                              >
                                Asignar
                              </Button>
                              <IconButton
                                size="small"
                                color="error"
                                onClick={() => eliminarVignette(v.id)}
                                title="Eliminar viñeta"
                              >
                                <Delete />
                              </IconButton>
                            </>
                          )}
                          {v.estado === 'ASIGNADO' && (
                            <Button
                              size="small"
                              variant="outlined"
                              color="warning"
                              startIcon={<Undo />}
                              onClick={() => devolverVignette(v.id)}
                            >
                              Devolver a Bodega
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}

      {/* Diálogo para Asignar Material */}
      <Dialog open={asignarDialogOpen} onClose={() => setAsignarDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Asignar Material a Técnico</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel>Material</InputLabel>
                <Select
                  value={asignarMaterial.material_id}
                  onChange={(e) => {
                    const materialId = e.target.value;
                    setAsignarMaterial({ ...asignarMaterial, material_id: materialId, cantidad: '1' });
                    if (materialId) {
                      cargarStockBodega(materialId);
                    } else {
                      setStockDisponible(0);
                    }
                  }}
                  label="Material"
                >
                  {materiales.map(m => (
                    <MenuItem key={m.id} value={m.id}>
                      {m.nombre} ({m.codigo}){m.proveedor ? ` — ${m.proveedor}` : ''} - Stock: {m.stock_bodega || 0} {m.unidad}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {asignarMaterial.material_id && (() => {
              const mat = materiales.find((x) => x.id === asignarMaterial.material_id);
              return mat ? (
                <Grid item xs={12}>
                  <Paper variant="outlined" sx={{ p: 1.5, bgcolor: '#fafafa' }}>
                    <Typography variant="body2"><strong>Proveedor:</strong> {mat.proveedor || 'Sin proveedor'}</Typography>
                    <Typography variant="body2"><strong>Observaciones:</strong> {mat.observaciones || '—'}</Typography>
                  </Paper>
                </Grid>
              ) : null;
            })()}
            {asignarMaterial.material_id && (
              <Grid item xs={12}>
                <Alert severity="info" sx={{ mt: 1 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="body2">
                      Stock disponible en bodega:
                    </Typography>
                    <Typography variant="body2" fontWeight="bold" color="primary">
                      {cargandoStock ? (
                        <CircularProgress size={20} />
                      ) : (
                        `${stockDisponible} ${materiales.find(m => m.id === asignarMaterial.material_id)?.unidad || 'unidades'}`
                      )}
                    </Typography>
                  </Box>
                </Alert>
              </Grid>
            )}

            <Grid item xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel>Técnico</InputLabel>
                <Select
                  value={asignarMaterial.tecnico_id}
                  onChange={(e) => setAsignarMaterial({ ...asignarMaterial, tecnico_id: e.target.value })}
                  label="Técnico"
                >
                  {tecnicos.map(t => (
                    <MenuItem key={t.id} value={t.id}>
                      {t.username || t.nombre || t.email}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              {/* ✅ CAMBIO 2: onChange simple + onFocus select + error corregido */}
              <TextField
                fullWidth
                type="number"
                label="Cantidad"
                value={asignarMaterial.cantidad}
                onChange={(e) => {
                  // ✅ Permitir vacío o números con punto decimal
                  const valor = e.target.value;
                  if (valor === '' || /^\d*\.?\d*$/.test(valor)) {
                    setAsignarMaterial({ ...asignarMaterial, cantidad: valor });
                  }
                }}
                onFocus={(e) => e.target.select()}
                size="small"
                inputProps={{
                  min: 0.1,
                  step: 0.1,
                  max: stockDisponible || 1
                }}
                helperText={`Máximo disponible: ${stockDisponible || 0}`}
                error={parseFloat(asignarMaterial.cantidad) > stockDisponible && stockDisponible > 0}
                disabled={!asignarMaterial.material_id || stockDisponible === 0}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setAsignarDialogOpen(false);
            setStockDisponible(0);
            // ✅ CAMBIO 5: reset con string
            setAsignarMaterial({ material_id: '', tecnico_id: '', cantidad: '1' });
          }}>Cancelar</Button>
          <Button
            variant="contained"
            onClick={asignarMaterialTecnico}
            // ✅ CAMBIO 6: validación con parseFloat
            disabled={
              loading ||
              !asignarMaterial.material_id ||
              !asignarMaterial.tecnico_id ||
              !asignarMaterial.cantidad ||
              parseFloat(asignarMaterial.cantidad) <= 0 ||
              parseFloat(asignarMaterial.cantidad) > stockDisponible
            }
          >
            Asignar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Diálogo para Asignar Viñeta */}
      <Dialog open={asignarVignetteOpen} onClose={() => setAsignarVignetteOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Asignar Viñeta a Técnico</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel>Viñeta</InputLabel>
                <Select
                  value={asignarVignette.vignette_id}
                  onChange={(e) => setAsignarVignette({ ...asignarVignette, vignette_id: e.target.value })}
                  label="Viñeta"
                >
                  <MenuItem value="">Seleccione una viñeta</MenuItem>
                  {vignettes.filter(v => v.estado === 'BODEGA').map(v => (
                    <MenuItem key={v.id} value={v.id}>
                      {v.serial} - {v.nombre}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel>Técnico</InputLabel>
                <Select
                  value={asignarVignette.tecnico_id}
                  onChange={(e) => setAsignarVignette({ ...asignarVignette, tecnico_id: e.target.value })}
                  label="Técnico"
                >
                  <MenuItem value="">Seleccione un técnico</MenuItem>
                  {tecnicos.map(t => (
                    <MenuItem key={t.id} value={t.id}>
                      {t.username || t.nombre || t.email}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAsignarVignetteOpen(false)}>Cancelar</Button>
          <Button
            variant="contained"
            onClick={asignarVignetteTecnico}
            disabled={loading || !asignarVignette.vignette_id || !asignarVignette.tecnico_id}
          >
            Asignar
          </Button>
        </DialogActions>
      </Dialog>

      {tabValue === 4 && <ProveedoresPanel />}
      {tabValue === 5 && <IngresosMaterialesPanel />}
      {tabValue === 6 && <LotesEquiposPanel />}

      {/* Notificaciones */}
      <Snackbar open={success} autoHideDuration={3000} onClose={() => setSuccess(false)} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert severity="success">Operación realizada exitosamente</Alert>
      </Snackbar>

      <Snackbar open={!!error} autoHideDuration={6000} onClose={() => setError('')} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert severity="error">{error}</Alert>
      </Snackbar>
    </Box>
  );
};

// Diálogo personalizado (necesario para el modal)
const Dialog = ({ open, onClose, maxWidth, fullWidth, children }) => {
  if (!open) return null;
  return (
    <Box sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      bgcolor: 'rgba(0,0,0,0.5)',
      zIndex: 1300,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <Paper sx={{ maxWidth: maxWidth === 'sm' ? 600 : 800, width: fullWidth ? '90%' : 'auto', p: 2 }}>
        {children}
      </Paper>
    </Box>
  );
};

const DialogTitle = ({ children }) => (
  <Typography variant="h6" sx={{ p: 2, pb: 0 }}>{children}</Typography>
);

const DialogContent = ({ children }) => (
  <Box sx={{ p: 2 }}>{children}</Box>
);

const DialogActions = ({ children }) => (
  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, p: 2, pt: 0 }}>{children}</Box>
);

export default NuevoEquipo;
